import { format, getTime, formatDistanceToNow } from "date-fns";
import { useMemo } from "react";
import { parsePhoneNumberFromString } from "libphonenumber-js/mobile";

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || "dd MMM yyyy";

  return date ? format(new Date(date), fm) : "";
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || "dd MMM yyyy p";

  return date ? format(new Date(date), fm) : "";
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : "";
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : "";
}

export function formatTime(timeString) {
  const [hourString, minute] = timeString.split(":");
  const hour = +hourString % 24;
  return (hour % 12 || 12) + ":" + minute + " " + (hour < 12 ? "AM" : "PM");
}

export const useDateUtils = () => {
  const currentMonthName = useMemo(() => {
    const currentDate = new Date();
    return currentDate.toLocaleString("default", { month: "long" });
  }, []);

  const lastMonthName = useMemo(() => {
    let currDate = new Date();
    let lastMonthDate = new Date(
      currDate.getFullYear(),
      currDate.getMonth() - 1,
      2
    );
    return lastMonthDate.toLocaleString("default", { month: "long" });
  }, []);

  const weekRange = useMemo(() => {
    const currentDate = new Date();
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());

    const endOfWeek = new Date(currentDate);
    endOfWeek.setDate(currentDate.getDate() + (6 - currentDate.getDay()));

    const formatDate = (date) =>
      `${date.getDate()} ${date.toLocaleString("default", { month: "short" })}`;

    return `${formatDate(startOfWeek)} - ${formatDate(endOfWeek)}`;
  }, []);

  const weekRangeLong = useMemo(() => {
    const currentDate = new Date();
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());

    const endOfWeek = new Date(currentDate);
    endOfWeek.setDate(currentDate.getDate() + (6 - currentDate.getDay()));

    const formatDate = (date) =>
      `${date.getDate()} ${date.toLocaleString("default", { month: "long" })}`;

    return `${formatDate(startOfWeek)} - ${formatDate(endOfWeek)}`;
  }, []);

  const currentYear = useMemo(() => {
    return new Date().getFullYear();
  }, []);

  const formatDate = (date) => date.toISOString().split("T")[0];
  const today = new Date();
  const todaysDate = useMemo(() => {
    return formatDate(today);
  }, []);

  const oneMonthAgoDate = useMemo(() => {
    let oneMonthAgo = new Date();
    oneMonthAgo.setDate(today.getDate() - 30);
    return formatDate(oneMonthAgo);
  }, []);

  return {
    currentMonthName,
    lastMonthName,
    weekRange,
    weekRangeLong,
    currentYear,
    todaysDate,
    oneMonthAgoDate,
  };
};

export const emailWithRequiredPattern = {
  required: "Email is required",
  pattern: {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    message: "Invalid email address",
  },
};

export const emailPattern = {
  pattern: {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    message: "Invalid email address",
  },
};

export const nameWithRequiredPattern = {
  required: "First name is required",
  pattern: {
    value: /^[A-Za-z\s'-]{2,50}$/,
    message: "Please enter a valid name",
  },
};

export const namePattern = {
  pattern: {
    value: /^[A-Za-z\s'-]{2,50}$/,
    message: "Please enter a valid name",
  },
};

export const validateMobile = (isdCode, mobileNumber, required) => {
  // Check Isd Code
  if (required) {
    if (!isdCode || isdCode === "") {
      return "Please select Isd code";
    }
  } else {
    if (!isdCode || isdCode === "") {
      return null; // Optional input — no value to validate
    }
  }
  
// Check Mobile Number
  if (required) {
    if (!mobileNumber || mobileNumber.trim() === "") {
      return "Please add mobile number";
    }
  } else {
    if (!mobileNumber || mobileNumber.trim() === "") {
      return null; // Optional input — no value to validate
    }
  }

  try {
    // Combine ISD code and number
    const fullNumber = `+${isdCode}${mobileNumber}`;
    const number = parsePhoneNumberFromString(fullNumber);

    if (!number || !number.isValid() || number.getType() !== "MOBILE") {
      return `Invalid mobile number for ISD code +${isdCode}`;
    }

    return null;
  } catch (err) {
    return `Invalid mobile number format for ISD code +${isdCode}`;
  }
};


export const validateCurrency =(countryId)=>{
  if(countryId===101) {
    return "₹"
  } 
   else if (countryId===153) {
return "रु"
  }
 }

 export const validateRuppes = (countryId)=>{
  if(countryId===101) {
    return "INR"
  } 
   else if (countryId===153) {
return "NPR"
  }
 }